import React from 'react';

export const CloseIcon = () => (
  <svg width="98" height="88" viewBox="0 0 98 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 85.4639L95.6417 2.00003M95.6418 85.4638L2.0001 2" stroke="#FF8310" strokeWidth="4.7482" />
  </svg>
);
